import { useEffect, useState } from "react";
import api from "../lib/api";
import { fmtUSD, fmtDate } from "../lib/format";
import { PageHeader, StatusBadge } from "../components/PageHeader";
import { DataTable } from "../components/DataTable";
import { Loader } from "../components/KpiCard";

export default function GeneralLedger() {
  const [rows, setRows] = useState(null);

  useEffect(() => { api.get("/ledger").then((r) => setRows(r.data)); }, []);
  if (!rows) return <Loader />;

  const columns = [
    { key: "transaction_id", label: "Txn ID", className: "font-mono text-xs text-[#5C5C54]" },
    { key: "transaction_date", label: "Date", render: (r) => fmtDate(r.transaction_date) },
    { key: "account_number", label: "Acct", className: "font-mono text-[#1A1A1A]" },
    { key: "account_name", label: "Account" },
    { key: "description", label: "Description", className: "text-[#5C5C54]" },
    { key: "debit", label: "Debit", align: "right", render: (r) => r.debit ? <span className="text-[#1A1A1A]">{fmtUSD(r.debit)}</span> : <span className="text-stone-300">—</span> },
    { key: "credit", label: "Credit", align: "right", render: (r) => r.credit ? <span className="text-[#1A1A1A]">{fmtUSD(r.credit)}</span> : <span className="text-stone-300">—</span> },
  ];

  const totalD = rows.reduce((s, r) => s + (r.debit || 0), 0);
  const totalC = rows.reduce((s, r) => s + (r.credit || 0), 0);

  return (
    <div>
      <PageHeader title="General Ledger" subtitle="The official double-entry accounting record — every debit has an equal credit."
        action={<StatusBadge tone={Math.abs(totalD - totalC) < 0.01 ? "green" : "red"}>
          {Math.abs(totalD - totalC) < 0.01 ? "In Balance" : "Out of Balance"}
        </StatusBadge>} />
      <div className="grid grid-cols-2 gap-6 mb-6 max-w-md">
        <div className="bg-white border border-stone-200 rounded-xl p-5">
          <div className="text-xs uppercase tracking-wider text-[#5C5C54]">Total Debits</div>
          <div className="font-mono text-xl font-semibold mt-1">{fmtUSD(totalD)}</div>
        </div>
        <div className="bg-white border border-stone-200 rounded-xl p-5">
          <div className="text-xs uppercase tracking-wider text-[#5C5C54]">Total Credits</div>
          <div className="font-mono text-xl font-semibold mt-1">{fmtUSD(totalC)}</div>
        </div>
      </div>
      <DataTable columns={columns} rows={rows} testid="ledger-table" empty={{ title: "No transactions posted" }} />
    </div>
  );
}
